import { render, staticRenderFns } from "./CardCommands.vue?vue&type=template&id=cd81c05e&scoped=true&"
import script from "./CardCommands.vue?vue&type=script&lang=js&"
export * from "./CardCommands.vue?vue&type=script&lang=js&"
import style0 from "./CardCommands.vue?vue&type=style&index=0&id=cd81c05e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd81c05e",
  null
  
)

export default component.exports